/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Title from "../../extras/Title";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { expertUpdate, getExpert } from "../../../redux/slice/expertSlice";
import { useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import { getAllServices } from "../../../redux/slice/serviceSlice";
import Button from "../../extras/Button";
import { ReactComponent as Star } from "../../../assets/images/star.svg";
import { ReactComponent as Mail } from "../../../assets/images/mail.svg";
import { ReactComponent as Call } from "../../../assets/images/call.svg";
import { ReactComponent as Age } from "../../../assets/images/age.svg";
import Male from "../../../assets/images/male.png";
import { ExInput } from "../../extras/Input";
import { permissionError } from "../../../util/Alert";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isLoading } from "../../../util/allSelector";
import { IconMail, IconOld, IconPhone, IconStar } from "@tabler/icons-react";

const ExpertProfile = () => {
  const { oneExpert } = useSelector((state) => state.expert);
  const { setting } = useSelector((state) => state.setting);
  const loader = useSelector(isLoading);

  const { state } = useLocation();
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [allService, setAllService] = useState([]);
  const { service } = useSelector((state) => state.service);
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  // useEffect(() => {
  //   dispatch(getAllServices({ start: 0, limit: 100, search: "ALL" }));
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getExpert(state?.id));
  }, [dispatch, state]);

  useEffect(() => {
    setData(oneExpert);
  }, [oneExpert]);

  useEffect(() => {
    const addData = oneExpert?.serviceData?.map((item) => {
      const { _id, ...rest } = item;
      return { id: _id, ...rest };
    });
    setAllService(addData);
  }, [oneExpert]);

  const serviceList = service?.map((list) => ({
    name: list.name,
    id: list._id,
  }));

  function onSelect(selectedList, selectedItem) {
    if (!hasPermission) return permissionError();
    allService?.length > 0 && allService.push(selectedItem);
  }

  return (
    <div className="userPage">
      {/* <Title
        name={`${
          data?.fname ? data?.fname + ` ` + data?.lname : "Salon Expert"
        }'s   Profile`}
      /> */}
      <div className="d-lg-flex d-md-block">
        <div className="col-12 col-sm-12 col-md-12 col-lg-3 mt-4 me-4">
          <div className="card">
            <div className="card-body pb-4">
              {loader === true ? (
                <>
                  <SkeletonTheme baseColor="#e2e5e7" highlightColor="#fff">
                    <p className="d-flex justify-content-center ">
                      <Skeleton
                        height={180}
                        width={180}
                        className="rounded-circle mb-2"
                      />
                    </p>
                    <Skeleton height={40} className="mb-5 border-bottom" />

                    <Skeleton count={4} height={30} className="mt-3" />
                  </SkeletonTheme>
                </>
              ) : (
                <>
                  <div className="position-relative">
                    <input
                      id="file-input"
                      type="file"
                      accept="image/*"
                      className="d-none"
                    />
                    <img
                      src={!data?.image?.includes("\\") ? data?.image : Male}
                      alt="admin"
                      className="mx-auto p-1 border "
                      style={{
                        width: 180,
                        height: 180,
                        objectFit: "cover",
                        display: "block",
                        borderRadius: "5px",
                      }}
                    />
                    <div
                      className="position-absolute"
                      style={{ bottom: "-2%", right: "45%" }}
                    >
                      <div
                        className="bg-theme"
                        style={{
                          borderRadius: 50,
                          height: 29,
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="text-center my-4  border-bottom ">
                    <h2 className="text-capitalize">
                      {data?.fname ? data?.fname + " " : "Salon"}
                      {data?.lname ? data?.lname : "User"}
                    </h2>
                    <div className="mt-4"></div>
                  </div>
                  <div>
                    <ul
                      style={{
                        listStyle: "none",
                        fontSize: 17,
                      }}
                    >
                      <li className="mt-4 user  userEdit">
                        <span className="ps-2">
                         <IconMail className="text-secondary"/>
                        </span>
                        <span className="ps-2">{data?.email}</span>
                      </li>
                      <li className="mt-4 user ">
                        <span
                          className="ps-2 "
                          style={{ height: "35px", width: "35px" }}
                        >
                         <IconPhone className="text-secondary"/>
                        </span>
                        <span className="ps-2">{data?.mobile}</span>
                      </li>
                      <li className="mt-4 user ">
                        <span
                          className="ps-2 "
                          style={{ height: "35px", width: "35px" }}
                        >
                         <IconOld className="text-secondary"/>
                        </span>
                        <span className="ps-2">{data?.age}</span>
                      </li>{" "}
                      <li className="mt-4 user -pointer">
                        <span
                          className="ps-2 "
                          style={{ height: "35px", width: "35px" }}
                        >
                         <IconStar className="text-secondary"/>
                        </span>
                        <span className="ps-2">
                          {data?.review ? data?.review : "-"}
                        </span>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xxl-9 mt-4">
          <div className="row">
            <div className="col-12">
              <div className="card ">
                <div className="card-body">
                  {loader === true ? (
                    <>
                      <SkeletonTheme
                        baseColor="#e2e5e7"
                        highlightColor="#fff"
                        className="mt-4"
                      >
                        <p>
                          <div className="mt-5">
                            <Skeleton count={4} height={40} className="mt-3" />
                          </div>
                        </p>
                      </SkeletonTheme>
                    </>
                  ) : (
                    <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9">
                      <div className="form-group ">
                        <div className="mb-1 mt-1 inputData">
                          <label className=" text-gray ml-3 font-weight-bold">
                            Salon commission
                          </label>
                          <input
                            type="text"
                            className=" p-2 inputNoFocus form-control"
                            placeholder="Salon Commission"
                            value={
                              (data?.commission ? data?.commission : 0) +
                              " " +
                              setting?.currencySymbol
                            }
                            readOnly
                          />
                        </div>
                        <div className="mb-1 mt-1 inputData">
                          <label className=" text-gray ml-3 font-weight-bold">
                            Earnings
                          </label>
                          <input
                            type="text"
                            className=" p-2 inputNoFocus form-control"
                            placeholder="Earnings"
                            value={
                              (data?.earning ? data?.earning : 0) +
                              " " +
                              setting?.currencySymbol
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group inputData">
                        <div className=" mt-2">
                          <label className=" text-gray ml-3 font-weight-bold">
                            Services
                          </label>
                          <input
                            type="text"
                            className=" p-2 inputNoFocus form-control"
                            placeholder="New Password"
                            value={
                              data?.totalBookingCount
                                ? data?.totalBookingCount
                                : "0"
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group inputData">
                        <div className=" mt-2">
                          <label className=" text-gray ml-3 font-weight-bold">
                            Joining date
                          </label>
                          <input
                            type="text"
                            className=" p-2 inputNoFocus form-control"
                            placeholder="New Password"
                            value={data?.createdAt?.split("T")[0]}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group inputData">
                        <div className="mb-2 mt-2">
                          <label className=" text-gray ml-3 font-weight-bold">
                            Services providing
                          </label>
                          <div className="interested-topics">
                            <Multiselect
                              // options={serviceList}
                              selectedValues={data?.serviceData?.map(
                                (item) => ({
                                  id: item._id,
                                  name: item.name,
                                })
                              )}
                              hideOnClickOutside={false}
                              // onSelect={onSelect}
                              // onRemove={onRemove}
                              displayValue="name"
                            />
                            {/* <div className="d-flex">
                            <Button
                              text={`Submit`}
                              className={` text-white ms-auto`}
                              style={{ backgroundColor: "#1ebc1e",marginTop : "30px"}}
                              onClick={(e) => handleSubmit(e)}
                            />
                          </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertProfile;
